import styled from "styled-components";
import bgImg from "../../assets/images/BGF2024_bg1.jpg";

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    color: #fefefe;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding-top: 20px;

    .border {
        border-left: 6px solid;
        border-image: linear-gradient(to top, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
        border-image-slice: 1;
    }
`;

export const Row = styled.div`
    background: #0a9e9e;
    -webkit-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    -moz-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    border-radius: 1.5%;
    display: flex;
    align-items: center;
    flex-direction: row;

    .container {
        margin: 50px;
    }
`;

export const Field = styled.span`
    color: #fefefe;
    width: 100%;
    text-align: left;
    font-size: 1em;
    max-width: 650px;
    word-wrap: break-word !important;
`;

export const Align = styled.div`
    width: 100%;
    display: flex;
    p + p {
        margin-left: 10px;
    }
`;

export const LogoName = styled.span`
    font-family: "Roboto";
    font-size: 26px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    flex-grow: 1;

    color: #fefefe;

    opacity: 0.6;
`;

export const Header = styled.div`
    overflow: hidden;
    background: linear-gradient(115.6deg, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
    padding: 20px 10px;
`;

export const Body = styled.div`
    overflow: flex;
    height: 100vh;
    background-color: #bffcfb;
`;

export const MapDisplay = styled.div`
    img {
        max-width: 100%;
        max-height: 100%;
    }
    .seat-content {
        overflow-x: scroll;
    }
    .seat-picker__row__number {
        visibility: hidden;
    }
`;

export const TermsField = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #fefefe;
    font-weight: 400;
    gap: 1em;
    font-size: 14px;

    div {
        display: flex;
        flex-direction: row;
        gap: 5px;
        justify-content: center;
        align-items: flex-start;
    }

    input {
        height: 16px;
        width: 16px;
        max-width: 16px;
        min-width: 16px;
        max-height: 16px;
        min-height: 16px;
        vertical-align: middle;
    }

    p {
        margin: 0;
        padding: 0;
        border: 0;
    }

    span {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const FormContainer = styled.div`
    width: 90%;
    max-width: 400px;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`;

export const StyledInput = styled.input`
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
`;

export const CheckboxContainer = styled.div`
    margin-bottom: 10px;
`;

export const CheckboxLabel = styled.label`
    display: block;
    margin-bottom: 5px;
`;
